var _title, _ellipse, _ellipse2, _line, _g, _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect4, _rect5, _rect6, _path18, _path19, _path20, _path21, _circle, _path22, _rect7, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _polygon, _polygon2, _rect8, _rect9, _rect10, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g2, _rect11, _rect12, _rect13, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g3, _polygon3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "688.466px",
    height: "691.465px",
    viewBox: "204.943 93.946 688.466 691.465",
    enableBackground: "new 204.943 93.946 688.466 691.465",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_084a417-9858-42b6-ae26-d97e116abc6c"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "product teardown")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    fill: "#CD1719",
    enableBackground: "new    ",
    cx: 753.62,
    cy: 754.32,
    rx: 118.88,
    ry: 20.45
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    fill: "#CD1719",
    enableBackground: "new    ",
    cx: 393.68,
    cy: 734.32,
    rx: 176,
    ry: 12.45
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 164,
    y1: 176.91,
    x2: 156.47,
    y2: 176.91
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.65,646.34c3.84,6.53,9.859,10.74,16.64,10.74c11.58,0,21-12.271,21-27.42c0-15.15-9.45-27.32-21-27.32 c-5.45,0-10.42,2.72-14.15,7.19c-1.414,1.71-2.613,3.587-3.569,5.59l-0.2,1.189c0,0-4.47,3.82-10.561,0.311V527.8h-86.72 c-1.425-1.866-1.818-4.321-1.05-6.54c0.647-2.03,2.046-3.736,3.91-4.77c6.53-3.84,10.75-9.86,10.75-16.641 c0-11.579-12.28-21-27.42-21c-15.14,0-27.42,9.391-27.42,21c0,5.45,2.73,10.431,7.2,14.16c1.708,1.409,3.582,2.604,5.58,3.561 l0.12,0.2c2.692,2.604,3.37,6.661,1.67,10h-39.11V692.25c0,21.539,17.461,39,39,39l0,0h113.52v-87.28 c1.887-1.791,4.619-2.37,7.07-1.5C403.926,643.107,405.622,644.492,406.65,646.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.7,524.34h13.58c-6.69-5.14-10.64-13.073-10.71-21.51c0-15.59,13.6-28.22,30.37-28.22s30.38,12.63,30.38,28.22 c-0.07,8.437-4.021,16.37-10.71,21.51h81.399v-87.63c1.896-1.771,4.618-2.35,7.07-1.5c2.035,0.643,3.746,2.042,4.78,3.91 c3.83,6.53,9.85,10.74,16.64,10.74c11.58,0,21-12.271,21-27.41c0-15.14-9.38-27.42-21-27.42c-5.46,0-10.43,2.73-14.16,7.19 c-1.41,1.713-2.608,3.59-3.569,5.59l-0.19,0.12c-2.761,2.882-7.15,3.468-10.57,1.41v-88.8h-83.49 c-1.424-1.866-1.818-4.322-1.05-6.54c0.644-2.033,2.043-3.74,3.91-4.77c6.53-3.83,10.74-9.86,10.74-16.64 c0-11.58-12.271-21-27.41-21c-15.14,0-27.42,9.39-27.42,21c0,5.46,2.73,10.43,7.19,14.16c1.713,1.41,3.59,2.609,5.59,3.57 l0.12,0.19c2.692,2.605,3.37,6.662,1.67,10H260.7v-4.5h17.84c-6.676-5.132-10.622-13.049-10.7-21.47 c0-15.59,13.6-28.23,30.38-28.23c16.78,0,30.37,12.64,30.37,28.23c-0.08,8.44-4.046,16.372-10.75,21.5h77.101v-88.7 c1.892-1.788,4.625-2.367,7.079-1.5c2.031,0.646,3.738,2.045,4.771,3.91c3.83,6.53,9.86,10.74,16.64,10.74 c11.58,0,21-12.27,21-27.42c0-15.15-9.38-27.41-21-27.41c-5.46,0-10.43,2.72-14.159,7.19c-1.415,1.71-2.614,3.587-3.57,5.59 l-0.19,1.19c0,0-4.47,3.82-10.569,0.31v-82.73H281.47c-21.54,0-39,17.461-39,39v42.22h-0.59c-1.265,0-2.29,1.025-2.29,2.29l0,0v20 c0.006,1.262,1.028,2.284,2.29,2.29h0.59v20.42h-0.77c-1.267,0-2.295,1.023-2.3,2.29v38.19c0.005,1.266,1.034,2.29,2.3,2.29h0.77 v15h-0.63c-1.265,0-2.29,1.025-2.29,2.29l0,0v12.3h-0.5v25.92c-0.005,1.259,1.011,2.285,2.27,2.29c0.007,0,0.014,0,0.02,0h0.68 v180.34H260.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.43,258.84c0-1.266-1.023-2.294-2.29-2.3h-1.38v-2.51h-0.75v-99.75c0.006-20.706-16.774-37.495-37.479-37.5 c-0.007,0-0.014,0-0.021,0h-112.5v76c5.209-6.913,13.345-11,22-11.05c15.71,0,28.45,13.61,28.45,30.39 c0,16.78-12.74,30.39-28.45,30.39c-8.656-0.047-16.793-4.135-22-11.05v84.33h91c-6.681-5.154-10.622-13.092-10.689-21.53 c0-15.61,13.569-28.26,30.319-28.26c7.445-0.042,14.663,2.56,20.37,7.34c11.529,9.212,13.408,26.025,4.196,37.554 c-1.238,1.55-2.646,2.958-4.196,4.196v0.67h19.75v-0.07h3.67V258.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.22,519.85v-10l0,0c0.412-0.601,0.79-1.226,1.13-1.869c1.34-2.437,2.048-5.17,2.061-7.95 c-0.003-1.854-0.321-3.693-0.94-5.44c-0.546-1.556-1.303-3.03-2.25-4.38l0,0c-4.609-6.63-13.72-11.15-24.22-11.15 c-15.15,0-27.42,9.391-27.42,21c0,5.461,2.729,10.431,7.19,14.16c1.713,1.41,3.59,2.609,5.59,3.57l0.12,0.189 c2.688,2.607,3.366,6.661,1.67,10H401.93v82c5.136-6.871,13.192-10.941,21.771-11c15.59,0,28.22,13.601,28.22,30.37 c0,16.771-12.63,30.38-28.22,30.38c-8.578-0.058-16.635-4.128-21.771-11v66.19h101.23c13.265,0,24.026-10.735,24.06-24V528.01l0,0 v162.8c0,13.288-10.771,24.061-24.06,24.061H401.93v16h105c21.539,0,39-17.461,39-39l0,0V528.01l0,0v-4.3h-18.71V519.85z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M286.09,711.2c-13.288,0-24.06-10.772-24.06-24.061V523.8h-18.71v164.45c0,21.539,17.461,39,39,39l0,0 h113.52v-16L286.09,711.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M402.84,638.47c2.034,0.641,3.743,2.041,4.771,3.91c3.84,6.53,9.859,10.74,16.64,10.74 c11.58,0,21-12.271,21-27.42c0-15.15-9.41-27.36-20.96-27.36c-5.45,0-10.42,2.72-14.15,7.19c-1.414,1.71-2.613,3.587-3.569,5.59 l-0.2,1.189c0,0-4.47,3.82-10.561,0.311V523.8h-86.72c-1.425-1.866-1.818-4.321-1.05-6.54c0.647-2.03,2.046-3.736,3.91-4.77 c6.53-3.84,10.75-9.86,10.75-16.641c0-11.579-12.28-21-27.42-21c-15.14,0-27.42,9.391-27.42,21c0,5.45,2.73,10.431,7.2,14.16 c1.708,1.409,3.582,2.604,5.58,3.561l0.12,0.2c2.692,2.604,3.37,6.661,1.67,10h-20.4V687.14c0,13.288,10.772,24.061,24.06,24.061 h109.75v-71.23C397.712,638.206,400.409,637.628,402.84,638.47z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 240.02,
    y: 311.71,
    fill: "#3A3768",
    width: 2.97,
    height: 4.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 245.47,
    y: 311.71,
    fill: "#3A3768",
    width: 16.23,
    height: 4.84
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 242.99,
    y: 311.71,
    fill: "#3A3768",
    width: 2.48,
    height: 4.84
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M401.93,525.67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M242.31,339.92h0.68v-23.38h-3v21.09c-0.006,1.259,1.01,2.285,2.27,2.291 C242.276,339.92,242.293,339.92,242.31,339.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M261.7,316.54h-16.23v21.09c0,1.265-1.025,2.29-2.29,2.29c-0.003,0-0.007,0-0.01,0h-0.18v180.42h18.71 V316.54z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M242.99,339.92h0.18c1.265,0.006,2.294-1.015,2.3-2.28c0-0.003,0-0.007,0-0.01v-21.09h-2.48L242.99,339.92z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M264.57,498.79c0-15.59,13.6-28.22,30.37-28.22s30.38,12.63,30.38,28.22 c-0.058,8.45-4.01,16.401-10.71,21.55h81.399v-87.63c1.896-1.771,4.618-2.35,7.07-1.5c2.035,0.643,3.746,2.042,4.78,3.91 c3.83,6.53,9.85,10.74,16.64,10.74c11.58,0,21-12.271,21-27.41c0-15.14-9.38-27.42-21-27.42c-5.46,0-10.43,2.73-14.16,7.19 c-1.41,1.713-2.608,3.59-3.569,5.59l-0.19,0.12c-2.761,2.882-7.15,3.468-10.57,1.41v-88.8h-83.49 c-1.424-1.866-1.818-4.322-1.05-6.54c0.644-2.033,2.043-3.74,3.91-4.77c6.53-3.83,10.74-9.86,10.74-16.64 c0-11.58-12.271-21-27.41-21c-15.14,0-27.42,9.39-27.42,21c0,5.46,2.73,10.43,7.19,14.16c1.713,1.41,3.59,2.609,5.59,3.57 l0.12,0.19c2.692,2.605,3.37,6.662,1.67,10H261.7v203.83h13.58C268.579,515.191,264.627,507.24,264.57,498.79z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M245.97,299.08c0-1.265-1.025-2.29-2.29-2.29c-0.003,0-0.007,0-0.01,0h-0.18v14.92h2.48V299.08z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M243.4,194.41h-0.5c-1.265,0-2.29,1.025-2.29,2.29l0,0v20c0.005,1.262,1.028,2.284,2.29,2.29h0.59v-24.57 L243.4,194.41z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M242.72,239.39c-1.267,0-2.295,1.023-2.3,2.29v38.19c0.005,1.266,1.034,2.29,2.3,2.29h0.77v-42.77H242.72z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M243.49,297.12h-0.65c-1.265,0-2.29,1.025-2.29,2.29l0,0v12.63h3L243.49,297.12z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M243.49,152.2v42.22c1.228,0.043,2.201,1.051,2.2,2.28v20c-0.004,1.227-0.974,2.231-2.2,2.28v20.42h0.35 c1.265,0,2.29,1.025,2.29,2.29l0,0v38.19c0,1.265-1.025,2.29-2.29,2.29l0,0h-0.37v15h0.18c1.267,0,2.294,1.024,2.3,2.29v12.58 h16.23v-158.7c0-13.284,10.766-24.054,24.05-24.06h32.61v4.18c0,10.941,8.869,19.81,19.811,19.81h57.369v-13.08H369.61 c-2.125-0.011-3.849-1.725-3.87-3.85v-0.84c0.005-2.135,1.734-3.864,3.87-3.87h26.359v-18.42h-113.5 C260.942,113.221,243.496,130.673,243.49,152.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M245.69,216.69v-20c0.001-1.229-0.972-2.237-2.2-2.28v24.55C244.712,218.912,245.68,217.913,245.69,216.69z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M246.15,279.87v-38.19c0-1.265-1.025-2.29-2.29-2.29l0,0h-0.37v42.77h0.35 c1.265,0.011,2.299-1.005,2.31-2.27C246.15,279.883,246.15,279.877,246.15,279.87z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M268.84,290.54c0-15.59,13.6-28.23,30.38-28.23c16.78,0,30.37,12.64,30.37,28.23 c-0.08,8.44-4.046,16.372-10.75,21.5h77.101v-88.7c1.892-1.788,4.625-2.367,7.079-1.5c2.031,0.646,3.738,2.045,4.771,3.91 c3.83,6.53,9.86,10.74,16.64,10.74c11.58,0,21-12.27,21-27.42c0-15.15-9.38-27.41-21-27.41c-5.46,0-10.43,2.72-14.159,7.19 c-1.415,1.71-2.614,3.587-3.57,5.59l-0.19,1.19c0,0-4.47,3.82-10.569,0.31v-42.7H338.6c-10.921-0.028-19.76-8.889-19.76-19.81 v-4.18h-32.59c-13.288,0.005-24.056,10.782-24.05,24.07c0,0.007,0,0.014,0,0.02v158.7h17.34 C272.855,306.901,268.909,298.971,268.84,290.54z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EC",
    d: "M369.61,131.6c-2.136,0.005-3.865,1.735-3.87,3.87v0.87c0.005,2.137,1.733,3.869,3.87,3.88h26.359v-8.59 L369.61,131.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M548.01,252.42v59.36h6.75v-61.75h-3.649C549.4,250.03,548.01,251.1,548.01,252.42z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 404.01,
    y: 112.78,
    fill: "#3A3768",
    width: 8,
    height: 18
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 404.01,
    y: 139.78,
    fill: "#3A3768",
    width: 8,
    height: 13
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 404.01,
    y: 130.78,
    fill: "#E6E8EC",
    width: 8,
    height: 9
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M556.14,252.54h-1.88v59.17h4.17v-56.87C558.43,253.574,557.406,252.545,556.14,252.54z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M412,130.78c2.13,0.479,4,4.36,4,4.36v0.84c0,0-1.88,3.87-4,3.8l0,0v13h45.19 c10.942-0.006,19.81-8.878,19.81-19.82v-4.18h34c13.263,0.027,24,10.787,24,24.05v116.51c11.529,9.212,13.407,26.025,4.196,37.554 c-1.239,1.55-2.646,2.958-4.196,4.196v0.67h14v-58.69c0-0.16,0.13-0.29,0.29-0.29c0.003,0,0.007,0,0.01,0h4.7v-102.5 c0.006-20.706-16.774-37.495-37.48-37.5c-0.006,0-0.013,0-0.02,0H411.01v18H412z M427.14,130.69c2.69,0,4.87,2.181,4.87,4.87 s-2.18,4.87-4.87,4.87c-2.689,0-4.87-2.181-4.87-4.87l0,0C422.27,132.871,424.45,130.69,427.14,130.69z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M425.96,177.72c15.71,0,28.45,13.61,28.45,30.39c0,16.78-12.74,30.39-28.45,30.39 c-8.656-0.048-16.793-4.135-22-11.05v84.33h91c-6.681-5.154-10.622-13.093-10.69-21.53c0-15.61,13.57-28.26,30.32-28.26 c7.463-0.051,14.701,2.555,20.42,7.35V152.83c0-13.263-10.737-24.022-24-24.05h-34v4.18c0,10.942-8.867,19.814-19.81,19.82h-53.19 v36C409.206,181.877,417.32,177.789,425.96,177.72z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EC",
    d: "M412,139.78c2.134,0.002,3.894-1.669,4-3.8v-0.84c-0.238-2.171-1.857-3.937-4-4.36h-1v9H412z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E8EC",
    cx: 427.141,
    cy: 135.538,
    r: 4.87
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M528.22,515.85v-10c4.254-5.855,4.254-13.784,0-19.64V515.85z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 528.22,
    y: 519.71,
    fill: "#3A3768",
    width: 18.71,
    height: 4.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M520.67,512.69c-1.865,1.031-3.264,2.738-3.91,4.77c-0.772,2.221-0.378,4.682,1.05,6.55h10.41v-4.3h-4 c1.45-1.16,2.789-2.452,4-3.86v-10C526.229,508.65,523.653,510.984,520.67,512.69z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M524.2,519.71h4v-3.86C526.989,517.258,525.649,518.55,524.2,519.71z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M531.41,496.05c-0.024-3.523-1.139-6.954-3.19-9.819v19.63C530.268,502.996,531.381,499.57,531.41,496.05z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M546.93,524.01v163.91c0,21.539-17.461,39-39,39l0,0h-105v-16h101.23c13.288,0,24.06-10.771,24.06-24.06 V524.01H546.93z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M516.76,517.46c0.646-2.031,2.045-3.738,3.91-4.77c2.982-1.703,5.559-4.033,7.55-6.83v-19.63 c-4.609-6.631-13.72-11.15-24.22-11.15c-15.15,0-27.42,9.39-27.42,21c0,5.46,2.729,10.43,7.189,14.16 c1.714,1.41,3.591,2.608,5.591,3.569l0.12,0.19c2.688,2.606,3.366,6.661,1.67,10H402.93v82c5.136-6.871,13.192-10.942,21.771-11 c15.59,0,28.22,13.6,28.22,30.37c0,16.77-12.63,30.38-28.22,30.38c-8.578-0.058-16.635-4.129-21.771-11v66.19h101.23 c13.265,0,24.026-10.736,24.06-24V524.01h-10.38C516.401,522.147,515.996,519.687,516.76,517.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1046.1689,
    y1: 188.9194,
    x2: 1046.1689,
    y2: 220.8696,
    gradientTransform: "matrix(1 0 0 -1 -332.8203 458.0596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M707.02,269.14c5.58-2.51,9.711-6.74,11.12-12.16c0.171-0.658,0.298-1.326,0.38-2 c0.25-0.624,0.463-1.262,0.641-1.91c1.41-5.44-0.141-11.07-3.82-15.88l-7.31,28l0,0L707.02,269.14z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2BE",
    d: "M625.99,385.23c8.229,3.12,27.359,3.46,35.859,3.46c2.58,0,4.181,0,4.181,0l5.45-11.1l-5.45-9.25 c0,0-5-1.38-11.641-2.58c-9.8-1.76-23.21-3.14-29.6,0.82C614.07,373.21,615.27,381.16,625.99,385.23z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M661.84,388.69c2.58,0,4.18,0,4.18,0l5.45-11.1l-5.439-9.25 c0,0-5-1.38-11.641-2.58C659.78,369.72,672.74,378.34,661.84,388.69z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4981",
    d: "M752.11,252.46l-2.4-2.78c0,0-12.39,19.6-13.69,27c-1.3,7.4-3,15.9-3,15.9s-3.14,9.62-5.18,13.87 s-3.88,8.32-4.06,10.17c-0.181,1.85,0.739,5.92-3.15,8.51c-3.89,2.59-4.8,9.62-4.8,9.62s-14.061,13.68-21.46,14 c-7.4,0.32-28.66,4.07-27.92,7.77s-8.87,5.91-12.76,6.84c-3.891,0.93,25,12,8.14,26.26c0,0,10.72,2.22,11.83,4.8 s12.39-1.47,12.39-1.47s2.41-5.74,10.73-6.11c8.319-0.37,12.569-4.07,12.569-4.62c0-0.55,8.32-5.18,13-6.47 c4.681-1.29,10.721-1.85,10.91-3.15c0.19-1.3,27.74-120.19,27.74-120.19L752.11,252.46z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    enableBackground: "new    ",
    d: "M752.11,252.46l-2.4-2.78c0,0-12.39,19.6-13.69,27c-1.3,7.4-3,15.9-3,15.9 s-3.14,9.62-5.18,13.87s-3.88,8.32-4.06,10.17c-0.181,1.85,0.739,5.92-3.15,8.51c-3.89,2.59-4.8,9.62-4.8,9.62 s-14.061,13.68-21.46,14c-7.4,0.32-28.66,4.07-27.92,7.77s-8.87,5.91-12.76,6.84c-3.891,0.93,25,12,8.14,26.26 c0,0,10.72,2.22,11.83,4.8s12.39-1.47,12.39-1.47s2.41-5.74,10.73-6.11c8.319-0.37,12.569-4.07,12.569-4.62 c0-0.55,8.32-5.18,13-6.47c4.681-1.29,10.721-1.85,10.91-3.15c0.19-1.3,27.74-120.19,27.74-120.19L752.11,252.46z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA8496",
    d: "M780.91,765.61c24.41,4.58,28.85-14.15,28.85-14.15s3.05-16.64,4.16-17.89 c0.279-0.478,0.348-1.05,0.19-1.58l0,0c-0.642-2.821-1.838-5.487-3.521-7.84c-1.52-1.801-0.28-9.29-0.28-9.29l-28.29-7.21 c0,0-2.5,5.68-2.77,8.319c-0.271,2.641-4.44,14.561-4,16.23c0.439,1.67-1.8,6.79-2.08,9.43s-3.74,6.521-4,7.9 c-0.436,1.25-0.946,2.472-1.53,3.66c-0.751,1.824-1.353,3.707-1.8,5.63C764.41,764.64,780.91,765.61,780.91,765.61z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M780.91,765.61c24.41,4.58,28.85-14.15,28.85-14.15s3.05-16.64,4.16-17.89 c0.279-0.478,0.348-1.05,0.19-1.58l-5.88,16.84c0,0-4.851,10.12-22.881,8.6c-10.26-0.87-15.31-2.77-17.76-4.25 c-0.751,1.825-1.353,3.708-1.8,5.63C764.41,764.64,780.91,765.61,780.91,765.61z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M799.91,739.26c0,0-6.1,0.141-6.521-4.85L799.91,739.26z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CD1719",
    points: "610.15,467.07 614.02,468.06 613.17,471.99 609.58,471.08  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    enableBackground: "new    ",
    points: "610.15,467.07 614.02,468.06 613.17,471.99 609.58,471.08  "
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 724.009,
    y: 284.865,
    transform: "matrix(-0.2468 0.9691 -0.9691 -0.2468 1183.7579 -346.2091)",
    fill: "#3A3768",
    width: 4.84,
    height: 4.17
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 710.547,
    y: 276.603,
    transform: "matrix(-0.2467 0.9691 -0.9691 -0.2467 1163.6333 -337.4528)",
    fill: "#3A3768",
    width: 4.841,
    height: 13.83
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 719.61,
    y: 283.393,
    transform: "matrix(-0.2467 0.9691 -0.9691 -0.2467 1177.1812 -343.3439)",
    fill: "#3A3768",
    width: 4.841,
    height: 4.889
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M707.07,278.86c-0.32,0.15-0.63,0.31-0.94,0.44l0.78,0.2l-1.2,4.69l-5.93-1.51 c-0.914-2.16-0.685-4.634,0.609-6.59c1.13-1.822,2.922-3.134,5-3.66c1.271-0.365,2.511-0.827,3.71-1.38L707.07,278.86z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M721.22,299.11l1.811,0.47c1.225,0.314,2.473-0.424,2.787-1.649c0.001-0.003,0.002-0.007,0.003-0.011 l2.02-8.08l-4-1L721.22,299.11z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M719.84,258.95c-1.38,5.4-5.39,9.61-10.81,12.1l7.1-27.9C719.73,247.94,721.24,253.55,719.84,258.95z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M718.7,298.47c-1.222-0.314-1.96-1.557-1.65-2.78l2.061-8.09l-13.4-3.41L664.84,444.73 c6.149,11.97,2.414,26.646-8.71,34.22l-0.95,3.74l18.13,4.649l47.91-188.19L718.7,298.47z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M717.05,295.69c-0.31,1.223,0.429,2.466,1.65,2.78l2.52,0.64l2.62-10.3l-4.729-1.21L717.05,295.69z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M700.38,276.09c1.136-1.816,2.926-3.126,5-3.66c1.266-0.368,2.503-0.829,3.7-1.38l7.109-27.9 c-4.449-5.653-10.687-9.63-17.689-11.28c-14.67-3.74-28.89,2.33-31.74,13.55c-1.35,5.29,0.07,10.78,3.48,15.5 c1.306,1.79,2.827,3.412,4.529,4.83l0.07,0.22c1.979,3.2,1.629,7.318-0.859,10.14l-89.66-22.83l-20.23,79.48 c6.651-5.387,15.434-7.361,23.75-5.34c15.11,3.85,24,20.15,19.86,36.4c-4.141,16.25-19.7,26.32-34.811,22.52 c-8.3-2.187-15.098-8.134-18.37-16.07l-20.77,81.56l79.42,20.21c-5.22-6.626-7.094-15.289-5.08-23.48 c3.85-15.1,20.14-24,36.4-19.859c8.781,2.15,16.203,7.996,20.35,16.03l40.87-160.541l-5.87-1.51 C698.906,280.531,699.108,278.058,700.38,276.09z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M706.9,279.5l0.17-0.64c-0.311,0.15-0.62,0.31-0.94,0.45L706.9,279.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M725.03,284.12l-4.73-1.21l-13.39-3.41l0,0l0.17-0.64l0,0l2-7.81c-1.2,0.554-2.44,1.015-3.71,1.38 c-2.078,0.526-3.871,1.838-5,3.66c-0.294,0.503-0.542,1.032-0.74,1.58c0.195-0.548,0.439-1.077,0.73-1.58 c1.135-1.816,2.925-3.126,5-3.66c1.266-0.368,2.502-0.829,3.699-1.38l7.11-27.9c-4.45-5.653-10.687-9.63-17.69-11.28 c-14.67-3.74-28.89,2.33-31.739,13.55c-1.351,5.29,0.069,10.78,3.479,15.5c1.307,1.79,2.828,3.412,4.53,4.83l0.07,0.22 c1.978,3.2,1.629,7.318-0.86,10.14l-89.66-22.83l-20.229,79.48c6.655-5.393,15.447-7.368,23.77-5.34 c15.11,3.85,24,20.15,19.86,36.4c-4.141,16.25-19.7,26.32-34.811,22.52c-8.3-2.187-15.098-8.134-18.37-16.07l-20.77,81.56 l79.42,20.21c-5.22-6.626-7.094-15.289-5.08-23.48c3.85-15.1,20.14-24,36.4-19.859c8.781,2.15,16.203,7.996,20.35,16.03 c6.149,11.97,2.414,26.646-8.71,34.22l-0.95,3.74l18.13,4.649l47.91-188.19l1.811,0.47c1.225,0.314,2.473-0.424,2.787-1.649 c0.001-0.003,0.002-0.007,0.003-0.011l2.02-8.12l1.19-4.69L725.03,284.12z M706.59,279.12c-0.149,0.07-0.3,0.15-0.45,0.21l0,0 L706.59,279.12z M699.79,282.71L699.79,282.71l5.93,1.51l0,0L699.79,282.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M719.84,258.95c1.37-5.4-0.14-11-3.71-15.8l-7.1,27.9C714.48,268.56,718.49,264.34,719.84,258.95z"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 724.99,
    y: 280.998,
    transform: "matrix(-0.2467 0.9691 -0.9691 -0.2467 1181.2188 -351.9921)",
    fill: "#3A3768",
    width: 4.841,
    height: 4.17
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 711.529,
    y: 272.736,
    transform: "matrix(-0.2465 0.9691 -0.9691 -0.2465 1160.9888 -343.3126)",
    fill: "#3A3768",
    width: 4.84,
    height: 13.83
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 720.595,
    y: 279.506,
    transform: "matrix(-0.2466 0.9691 -0.9691 -0.2466 1174.5343 -349.2206)",
    fill: "#3A3768",
    width: 4.84,
    height: 4.89
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M722.2,295.24l1.819,0.46c1.222,0.33,2.479-0.393,2.809-1.614c0.004-0.015,0.008-0.031,0.012-0.046 l2.061-8.08l-4-1L722.2,295.24z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M720.84,255.08c-1.37,5.39-5.38,9.6-10.81,12.09l7.109-27.9C720.72,244.06,722.23,249.67,720.84,255.08z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M719.689,294.6c-1.225-0.313-1.964-1.561-1.65-2.786c0-0.001,0-0.002,0.001-0.004l2-8.08l-13.34-3.39 L665.84,440.86c6.163,11.965,2.425,26.648-8.71,34.21l-0.95,3.739l18.141,4.62L722.22,295.24L719.689,294.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3768",
    d: "M718.04,291.81c-0.315,1.225,0.421,2.473,1.646,2.789c0.001,0,0.002,0,0.004,0.001l2.51,0.64l2.64-10.31 l-4.74-1.2L718.04,291.81z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M701.37,272.21c1.133-1.818,2.924-3.129,5-3.66c1.267-0.365,2.504-0.826,3.7-1.38l7.1-27.9 c-4.447-5.652-10.68-9.629-17.68-11.28c-14.681-3.73-28.891,2.33-31.75,13.56c-1.34,5.28,0.069,10.77,3.49,15.49 c1.306,1.793,2.827,3.418,4.529,4.84l0.07,0.21c1.972,3.202,1.623,7.316-0.86,10.14l-89.67-22.82l-20.26,79.47 c6.663-5.401,15.47-7.374,23.8-5.33c15.101,3.84,24,20.14,19.86,36.4c-4.141,16.26-19.71,26.31-34.86,22.47 c-8.289-2.202-15.073-8.15-18.34-16.08L534.74,447.9l79.41,20.22c-5.217-6.628-7.087-15.29-5.07-23.48 c3.84-15.109,20.14-23.999,36.4-19.859c8.799,2.15,16.229,8.019,20.359,16.08L706.7,280.34l-5.931-1.51 C699.843,276.663,700.068,274.175,701.37,272.21z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M707.89,275.63l0.16-0.65c-0.31,0.15-0.62,0.31-0.93,0.45L707.89,275.63z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEDDF9",
    d: "M693.84,575.34c3,4.57,6.521,24.55,6.521,24.55s2.359,4.57,2.22,8.46c-0.14,3.891,2.22,11,2.22,11 l7.771,28.71c0,0-0.84,7.631,2.08,13c2.92,5.37,2.63,3.74,1.25,13.171c-1.381,9.43,1.659,18.17,6.649,21 c4.99,2.829-2.22,9.29-2.22,9.29s31.9,8.6,38.56,3.329c6.66-5.27-3.47-31.35-3.47-31.35s1.67-21.91,0.561-25.1 c-1.11-3.19-5.83-30.37-5.83-30.37s-2.91-12.351-1.801-14.43c1.11-2.08-0.689-8-0.689-8s-4.72-6.66-4.3-8.74 s-1.391-5.82-1.391-5.82s14.12-21.7,12.87-25.77c-1.25-4.07,0.55-10.54,0.55-10.54l3.94-6.74c2.63-4.5,5.81-9.891,6.88-11.57 c1.36-2.14,4.64-11.24,6.47-16.49l1.301-3.76c0,0,2.22,40.78,4.159,44.94c1.94,4.16,4.851,37,4.851,37 c1.078,2.924,1.551,6.037,1.39,9.149c-0.28,5.13,4.44,27.46,4.44,27.46s2.08,15.811,0.689,20c-1.39,4.19-0.28,34.82-0.28,34.82 s-7.63,6-9.569,10.54c-1.94,4.54,0.279,17,0.279,17s22.19,11.1,32,8.19c9.811-2.91,5.82-19.7,5.82-19.7s6.66-11.09,6.66-15.391 c0-4.3,2.42-17.43,2.42-17.43c8.46-15.53,5.13-53.25,6.521-56.3c1.39-3.05-2.92-14.43-6.38-19.561c-3.461-5.13-2.08-19,0-23 s-2.141-17.909-2.141-17.909s4-26.91,3.88-31.07s3.47-16.5,3.47-16.5s3.601-6.38,2.771-8.33s2.771-6.93,1.8-9.15 c-0.97-2.22,0.84-9,2.641-13c0.92-2.06,2.069-7.739,3-12.77c0.85-4.79,1.479-9,1.479-9l-22.89-18.45l-57.141-15l-21.489-6.93 l-20.95,33c-1.481,2.406-2.84,4.886-4.07,7.43c-1.65,3.43-3.12,7.25-2.859,9.63c0.349,3.004-0.336,6.037-1.94,8.601 c0,0-12.49,39.52-12.21,50.899s-4.44,36.33-4.44,36.33S690.76,570.75,693.84,575.34z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2BE",
    d: "M778.3,253.84c0.88-0.36,61.21-25.28,52.9-30.23c-4.931-2.94-11-15.4-15.16-25.15 c-2.9-6.81-4.87-12.3-4.87-12.3s-48.42-8.6-31.09,21.08c2.731,4.553,4.79,9.477,6.11,14.62 C791.13,242.08,778.7,253.47,778.3,253.84z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M780.08,207.24c2.731,4.553,4.789,9.477,6.109,14.62 c12.521-0.871,23.528-8.606,28.591-20.09c0.48-1.08,0.9-2.185,1.26-3.31c-2.9-6.81-4.87-12.3-4.87-12.3 S762.75,177.56,780.08,207.24z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2BE",
    d: "M749.98,186.99c0.006,18.684,15.158,33.824,33.842,33.818c18.684-0.007,33.824-15.159,33.817-33.842 c-0.007-18.684-15.158-33.825-33.842-33.818c-15.075,0.005-28.328,9.985-32.498,24.472 C750.424,180.666,749.979,183.82,749.98,186.99z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M717.34,449.2c3.54,3.22,4.9,9.35,4.9,9.35s16.649,11.37,15.54,4.16 c-1.11-7.21,8.6-36.34,8.6-36.34l-1.11,39.67c0,0,53.25-2.5,57.141-6.38c3.89-3.88,26.63-11.32,26.63-11.32s7,5.59,13.36,9.83 c0.85-4.79,1.479-9,1.479-9l-22.89-18.45l-57.141-14.999l-21.489-6.931l-20.95,33C719.93,444.19,718.571,446.663,717.34,449.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M715.59,446.07c4.44,2.77,6.1,10.26,6.1,10.26s16.641,11.37,15.53,4.16 c-1.109-7.21,8.601-36.34,8.601-36.34l-1.11,39.67c0,0,53.26-2.48,57.13-6.38c3.87-3.9,26.63-11.37,26.63-11.37 s19.7,15.81,23.3,14.42c3.601-1.391-6.38-28.29-6.38-28.29l-10.25-157.55c0,0,2.771-46.88-1.39-48.55 c-0.642-0.26-1.234-0.628-1.75-1.09c-2.74-2.46-3.561-7.46-3.8-11.66c-0.271-5-6.931-2.5-6.931-2.5l3.881,5l-34.37,20.9l-0.3,0.18 c-1.339-0.705-2.718-1.33-4.131-1.87c-3-1.17-7.09-2.27-9.739-1.18c-1.481,0.753-2.737,1.885-3.641,3.28 c-1.96,2.946-3.533,6.132-4.68,9.48l-12.45,21.07c0,0-6.38,28-6.38,29.13c0,1.13-1.94,26.63-4.16,29.4 c-2.22,2.77-4.439,16.64-3.609,20.8c0.829,4.16-1.391,19.7-1.391,19.7c-9.149,7.49-13.859,33-13.859,33s-14.46,28.6-15.601,31.899 C709.7,434.94,711.15,443.34,715.59,446.07z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M790.78,237.85c3.37,5,13.109,12,13.109,12L832,226.1 c-2.74-2.46-3.561-7.46-3.8-11.67c-0.271-5-6.931-2.49-6.931-2.49l0.811,1c1.516,1.956,1.158,4.77-0.797,6.286 c-0.133,0.103-0.271,0.197-0.413,0.285L790.78,237.85z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M790.78,236.74c3.37,5,13.109,12,13.109,12L832,224.99c-2.74-2.46-3.561-7.46-3.8-11.66 c-0.271-5-6.931-2.5-6.931-2.5l0.811,1c1.514,1.95,1.159,4.758-0.791,6.271c-0.135,0.104-0.274,0.2-0.419,0.289L790.78,236.74z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M777.78,240.48c3.63,4.34,8.78,9.27,8.54,6.8c-0.24-2.47,3.069-7.92,5.18-10.36 c-3.296-1.044-6.848-0.946-10.08,0.28C779.937,237.95,778.68,239.082,777.78,240.48z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M777.23,238.81c3.63,4.35,8.77,9.27,8.529,6.81s2.73-6.47,4.84-8.91c-3-1.17-7.08-2.27-9.739-1.17 C779.38,236.287,778.127,237.416,777.23,238.81z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 786.32,
    cy: 259.67,
    r: 2.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 769.49,
    cy: 319.58,
    r: 2.22
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 750.45,
    cy: 380.24,
    r: 2.22
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 749.89,
    cy: 446.25,
    r: 2.22
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 776.52,
    cy: 287.96,
    r: 2.22
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 761.54,
    cy: 349.54,
    r: 2.22
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 746.93,
    cy: 410.01,
    r: 2.22
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF718D",
    cx: 750.26,
    cy: 453.65,
    r: 2.22
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M832,226.34c0,0-0.37-3.33,4.43,2.41c4.801,5.74,13.87,10.72,13.87,10.72 s20.53,14.43,21.64,21.08c1.11,6.65,7.761,35.51,4.25,45.12c-3.51,9.61-30.35,55.67-30.35,55.67s7,8.33,5.37,18.13 c-1.63,9.8-3.7,23.3-2.78,26.26s-1.109,10.35,2,12.94c3.11,2.59,6.471,7-3.33,12.94c0,0-1.85,5-0.189,6.109 c1.66,1.11-24.59,12.57-35,6.471c-10.41-6.101-29-54.92-29.4-65.831c-0.4-10.91,5.73-47,9.061-55.48s13.319-41.61,17.569-49 C813.39,266.49,832,226.34,832,226.34z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4981",
    d: "M833.1,226.34c0,0-0.369-3.33,4.44,2.41c4.81,5.74,13.87,10.72,13.87,10.72s20.53,14.43,21.64,21.08 c1.11,6.65,7.761,35.51,4.25,45.12c-3.51,9.61-30.33,55.67-30.33,55.67s7,8.33,5.37,18.13c-1.63,9.8-3.7,23.3-2.78,26.26 c0.921,2.96-1.109,10.35,2,12.94c3.11,2.59,6.471,7-3.329,12.94c0,0-1.851,5-0.19,6.109c1.66,1.11-24.59,12.57-35,6.471 c-10.41-6.101-29-54.92-29.4-65.831c-0.399-10.91,5.73-47,9.061-55.48s13.319-41.61,17.569-49 C814.52,266.49,833.1,226.34,833.1,226.34z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M840.5,257.82c0,0-15.9,17.57-15.35,29.22 C825.15,287.04,824.97,268.17,840.5,257.82z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M818.5,286.67c0,0.55-10.73,40.49-10.17,45.49c0.56,5-3.15,19.78-3.15,19.78 l-5-1.29c0,0,3.88-20.53,4.62-28.11S818.5,286.67,818.5,286.67z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M814.24,400.58c0.37,0.55,25.34,28.84,18.31,30.88S814.24,400.58,814.24,400.58 z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M834.77,393.34c0.551,0.37,10,20.34,11.091,15c1.09-5.34-8.13,14.61-9.61-0.18 L834.77,393.34z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M786.84,232.67c0,0-10.31-6.29-23.26,9.8c0,0-9.43,5.36-12.2,6.66 c-2.77,1.3-5.92,35.69-5.92,35.69s-6.1,14.79-4.44,23.3c1.66,8.51-4.8,37.72-4.8,37.72s-10.739,52.5-10.38,54 c0.36,1.5,10.91-16.46,10.73-25.34c-0.181-8.88,8.869-36.61,10.17-38.28c1.3-1.67,10.17-49.18,10.17-49.18s7.21-20.16,11.83-26.82 c4.62-6.66,10.359-19.23,12.76-21.45c1.728-1.495,3.656-2.741,5.73-3.7L786.84,232.67z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4981",
    d: "M786.97,232.67c0,0-11.56-6.29-24.5,9.8c0,0-9.439,5.36-12.21,6.66c-2.77,1.3-5.92,35.69-5.92,35.69 s-6.1,14.79-4.439,23.3c1.659,8.51-4.801,37.72-4.801,37.72s-10.729,52.52-10.359,54s10.91-16.46,10.729-25.34 c-0.18-8.88,8.87-36.61,10.17-38.28c1.3-1.67,10.2-49.18,10.2-49.18s7.21-20.16,11.83-26.82c4.62-6.66,10.36-19.23,12.76-21.45 c2.4-2.22,6.84-3.7,6.84-3.7L786.97,232.67z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2BE",
    d: "M736.21,348.24c0,0-22-14.42-32.64-7.3c-10.641,7.12-28,17.2-10.91,24.5c17.09,7.3,40.77,5.9,40.77,5.9 L736.21,348.24z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M751.51,487.4c3.28,7,6,42.38,7.82,53.59c2.63-4.5,5.81-9.891,6.88-11.57 c1.36-2.14,4.64-11.24,6.47-16.49c-2.09-5.08-7.859-19.64-7.859-25c0-6.52-10.54-14.699-10.54-14.699S747.63,479.08,751.51,487.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M822.24,595.99c0,0-24.41-10.4-31.62-3 C783.41,600.39,822.24,595.99,822.24,595.99z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M808.51,600.15c0,0,24.69,13.87,16.23,16.189 C816.28,618.66,808.51,600.15,808.51,600.15z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M734.73,588.09c0,0,10.539,0.69,6.52,2.771S734.73,588.09,734.73,588.09z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M721.55,591.28c0.141,0.689,30.65,10.54,24.69,15S721.55,591.28,721.55,591.28z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M818.63,676.16c-4.57-0.7-30.09-12.49-20.11-4 C808.5,680.65,818.63,676.16,818.63,676.16z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M806.01,685.45c0,0-2.22,8.6-10.68,7.49 C786.87,691.83,806.01,685.45,806.01,685.45z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M813.09,702.92c-1.53-0.41-19.7-8.729-20.109-4.85 c-0.41,3.88,17.33,10.68,18.72,8.6C812.497,705.57,812.978,704.273,813.09,702.92z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M754.28,692.94c-2.22-0.141-23-6.801-27.181-0.841L754.28,692.94z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M735.42,696.82c0,0-3.609-3.19-7.21-1.53 C724.61,696.95,735.42,696.82,735.42,696.82z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M781.47,731.22c-0.477,2.407-2.326,4.309-4.72,4.851L781.47,731.22z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA8496",
    d: "M675.64,744.25c1.391,5.69,20.811,6.24,30.101,4.72c9.29-1.52,28.569-7.08,28.569-7.08 s20.25-1.939,26.21-4.43c5.961-2.49,1.25-8.88,1.25-8.88s0-0.22,0-0.601c0.141-2.319,0.561-10.729-0.869-13 c-1.66-2.64-0.69-11.239-0.69-11.239s-28.71,5.55-29.271,2.92c-0.56-2.63-5-6.38-7.069-7.21c-2.07-0.83-3.61,6.93-3.61,6.93 s-13,11.1-13.87,15.12c-0.87,4.02-10,6.1-10,6.1s-13.87,3.88-17.479,5.82c-2.131,1.002-3.581,3.048-3.82,5.39 C674.938,740.642,675.125,742.485,675.64,744.25z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M675.64,744.25c1.391,5.69,20.811,6.24,30.101,4.72 c9.29-1.52,28.569-7.08,28.569-7.08s20.25-1.939,26.21-4.43c5.961-2.49,1.25-8.88,1.25-8.88s0-0.22,0-0.601l-29,6.431 c0,0-14.289,6.1-23.439,6.1c-8,0-25.9,3.271-34.2-1.689C674.967,740.646,675.14,742.486,675.64,744.25z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M714.89,722.34c0,0,1.391,9.15,6.94,12.2L714.89,722.34z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M751.3,177.62c0.528,0.279,1.081,0.51,1.65,0.69c2.6,0.7,5.14-1.06,7.45-2.46 c2.31-1.4,5.5-2.44,7.5-0.62c2.609,2.37,0.72,7.43,3.41,9.72c1.699,1.45,4.399,0.95,6.289,2.14c1.891,1.19,2.461,3.8,2.94,6.05 s1.44,4.82,3.64,5.48c2.2,0.66,4.25-0.79,6.42-0.71c0.45,0,1,0.07,1.28-0.25c0.198-0.293,0.274-0.652,0.21-1 c-0.271-2.688-0.03-5.402,0.71-8c0.891-2.56,3-4.87,5.641-5.28c3.89-0.6,7.159,2.81,9.45,6c2.407,3.378,4.598,6.905,6.56,10.56 c0.124,0.237,0.234,0.48,0.33,0.73c7.565-17.089-0.155-37.076-17.245-44.642c-17.09-7.565-37.076,0.155-44.642,17.245 c-0.632,1.428-1.164,2.897-1.594,4.397V177.62z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5E7F",
    d: "M807.89,188.82c-2.29-3.22-5.56-6.62-9.46-6c-2.67,0.41-4.729,2.72-5.63,5.27 c-0.741,2.598-0.979,5.313-0.7,8c0.056,0.349-0.022,0.707-0.22,1c-0.31,0.33-0.83,0.28-1.28,0.26c-2.17-0.08-4.33,1.33-6.42,0.71 s-3.16-3.23-3.64-5.48c-0.48-2.25-1-4.82-2.94-6.05c-1.939-1.23-4.59-0.69-6.29-2.15c-2.689-2.28-0.79-7.35-3.409-9.72 c-2-1.81-5.19-0.77-7.5,0.63c-2.311,1.4-4.851,3.15-7.461,2.45c-0.88-0.24-1.67-0.74-2.529-1.07c-4.11-1.57-9.44,1.09-12.82-1.73 c-1.227-1.227-2.109-2.754-2.56-4.43c-0.928-2.266-1.557-4.642-1.87-7.07c-0.299-2.454,0.376-4.928,1.88-6.89 c2.2-2.59,5.92-3.24,8.729-5.15c2.391-1.64,4-4.13,5.58-6.58c1.58-2.45,3.11-5,5.42-6.73c2.311-1.73,5.551-2.59,8.131-1.28 c0.813,0.568,1.716,0.997,2.67,1.27c1.04,0.013,2.063-0.268,2.949-0.81c9.62-4.53,20.82-3.73,31.37-2.38 c4.22,0.54,8.5,1.17,12.351,3c3.85,1.83,7.25,5,8.33,9.12c0.859,3.26,0.199,6.81,1.239,10c0.7,2.18,2.141,4,3,6.19 c2.25,5.85-0.439,12.27-1.58,18.43c-1.239,6.73-0.62,14-3.479,20.38c-0.561,1.25-1.19,3.44-2.6,2.62c-1-0.61-2.061-4.16-2.66-5.27 C812.518,195.709,810.313,192.189,807.89,188.82z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M868.84,297.21l5,14.24c0,0-11.84,44-17.39,53.25s-13.681,21.08-13.681,21.08 s-13.68,6.85-29.59,3.7s-62.34-11.46-62.34-11.46s-3.89,0.74-5.92-2.22s-12.6-4.46-12.6-4.46s-12.2-17.75,2.779-25.15 c0,0,1.851,4.07,9.801,1.3c7.949-2.77,10.35,2.21,10.35,2.21s13,2.59,20.16,1.67s25.149-1.3,27-2.78 c0.976-0.855,2.457-0.771,3.33,0.19c0,0,4.43-1.66,5.91-3.33c1.479-1.67,3.52,1.85,3.52,1.85s2.59-1.48,1.85-3.33 c-0.739-1.85,2.4-8.87,2.4-8.87s1.48-4.63,0.561-8.33c-0.921-3.7,4.619-17,4.619-17c0.072-2.244-0.177-4.487-0.739-6.66 c-0.931-3.32,7-10,7-10s7.76-37.73,24.22-25.34S868.84,297.21,868.84,297.21z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4981",
    d: "M869.9,297.21l5,14.24c0,0-11.841,44-17.391,53.25s-13.67,21.08-13.67,21.08s-13.68,6.85-29.59,3.7 s-62.32-11.46-62.32-11.46s-3.88,0.74-5.91-2.22c-2.029-2.96-12.59-4.46-12.59-4.46s-12.199-17.75,2.78-25.15 c0,0,1.851,4.07,9.8,1.3c7.95-2.77,10.351,2.21,10.351,2.21s13,2.59,20.159,1.67c7.16-0.92,25.15-1.3,27-2.78 c0.977-0.855,2.458-0.771,3.33,0.19c0,0,4.431-1.66,5.91-3.33c1.48-1.67,3.521,1.85,3.521,1.85s2.59-1.48,1.85-3.33 c-0.74-1.85,2.4-8.87,2.4-8.87s1.479-4.63,0.55-8.33c-0.93-3.7,4.63-17,4.63-17c0.072-2.244-0.177-4.487-0.74-6.66 c-0.93-3.32,7-10,7-10s7.761-37.73,24.22-25.34C872.65,280.16,869.9,297.21,869.9,297.21z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M749.71,356.75c0.18,1.3,4.25,6.47,2.771,7.4c-1.48,0.93-3.881,0.37-1.66,3.33 c2.22,2.96,2,7.39,0.55,6.84c-1.45-0.55-3.88-7.21-3.88-9.8S749.71,356.75,749.71,356.75z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M804.63,353.79c0,0,1.11,12.95,10.21,16.65 C823.939,374.14,804.63,353.79,804.63,353.79z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M823.49,349.34c0.55,0.19,12.939,6.85,7.399,10.73 C825.35,363.95,823.49,349.34,823.49,349.34z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M824.23,340.11c0,0,18.119,3.7,12,6.84 C830.11,350.09,824.23,340.11,824.23,340.11z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792.84,184.92c0.9-2.55,3-4.86,5.63-5.27c3.9-0.6,7.17,2.81,9.46,6c2.408,3.378,4.599,6.905,6.561,10.56 c0.6,1.11,1.62,4.65,2.66,5.26c1.409,0.83,2-1.36,2.6-2.61c2.86-6.36,2.24-13.65,3.48-20.38c0.729-3.93,2.079-8,2.38-11.9 c0.43,4.84-1.471,9.93-2.38,14.85c-1.24,6.73-0.62,14-3.48,20.39c-0.561,1.25-1.19,3.44-2.6,2.61c-1-0.61-2.061-4.15-2.66-5.26 c-1.962-3.655-4.152-7.182-6.561-10.56c-2.29-3.21-5.56-6.62-9.46-6c-2.67,0.41-4.729,2.72-5.63,5.27 c-0.446,1.344-0.695,2.745-0.74,4.16C791.902,189.642,792.152,187.227,792.84,184.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.03,167.34c0.448,1.679,1.331,3.211,2.56,4.44c3.38,2.82,8.71,0.16,12.82,1.729c0.859,0.32,1.65,0.83,2.53,1.07 c2.609,0.69,5.159-1.06,7.46-2.46c2.3-1.4,5.51-2.43,7.5-0.62c2.619,2.37,0.72,7.43,3.41,9.72c1.699,1.45,4.399,1,6.289,2.15 c1.891,1.15,2.461,3.79,2.94,6s1.43,4.82,3.64,5.48c2.21,0.66,4.25-0.78,6.42-0.7c0.45,0,1,0.07,1.28-0.26 c0.065-0.084,0.116-0.179,0.15-0.28c0,0.75,0,1.49,0.069,2.23c0.055,0.349-0.023,0.706-0.22,1c-0.31,0.32-0.83,0.27-1.28,0.25 c-2.17-0.07-4.33,1.33-6.42,0.71c-2.09-0.62-3.159-3.22-3.64-5.48c-0.479-2.26-1-4.82-2.94-6c-1.939-1.18-4.59-0.7-6.289-2.15 c-2.69-2.29-0.79-7.36-3.41-9.72c-2-1.82-5.19-0.78-7.5,0.62c-2.311,1.4-4.851,3.15-7.46,2.46c-0.88-0.24-1.67-0.75-2.53-1.07 c-4.11-1.57-9.44,1.09-12.82-1.73c-1.227-1.231-2.109-2.762-2.56-4.44c-0.927-2.262-1.556-4.636-1.87-7.06 c-0.07-0.826-0.05-1.658,0.06-2.48C733.568,163.009,734.176,165.22,735.03,167.34z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF1F0",
    points: "705.669,284.391 705.712,284.219 710.501,265.272 694.84,267.673 694.84,279.5  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M329.34,437.415l7.333-86.012c0,0,45,4.104,43,46.437C379.673,397.84,373.006,437.99,329.34,437.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    d: "M300.34,360.726c0,0,9.667-10.425,32-9.322l-3,37.287L300.34,360.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M298.673,362.34c0,0-31.333,17.699-9.333,56.1c0,0,11.333,17.218,35.333,18.976l3.333-43.45L298.673,362.34 z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD1719",
    cx: 300.34,
    cy: 451.43,
    r: 8.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 324.673,
    cy: 451.43,
    r: 8.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 281.508,
    cy: 234.786,
    r: 6.471
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 281.508,
    cy: 207.921,
    r: 6.471
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 281.508,
    cy: 178.614,
    r: 6.471
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E6E6",
    cx: 350.108,
    cy: 451.43,
    r: 8.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M626.798,391.298"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010068",
    strokeMiterlimit: 10,
    points: "590.673,407.79 654.39,423.84 689.199,295.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CD1719",
    points: "629.34,293.355 681.674,307.065 678.007,321.256 625.955,307.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CD1719",
    points: "633.173,318.108 675.757,328.673 672.332,342.524 630.13,332.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CD1719",
    points: "670.007,350.84 666.341,364.59 646.007,359.053 650.007,345.173  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#CD1719",
    points: "664.424,371.923 660.757,386.045 624.97,376.006 627.839,362.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#CD1719",
    points: "658.341,395.28 654.57,409.47 633.173,403.675 637.215,389.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010068",
    strokeMiterlimit: 10,
    points: "625.955,395.28 619.34,368.225 636.339,348.736  622.673,320.775 620.34,299.11  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3768",
    cx: 636.339,
    cy: 348.736,
    r: 2.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3768",
    cx: 619.34,
    cy: 368.225,
    r: 2.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3768",
    cx: 625.955,
    cy: 395.28,
    r: 2.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3768",
    cx: 620.34,
    cy: 299.11,
    r: 2.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3768",
    cx: 622.673,
    cy: 320.775,
    r: 2.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3A3768",
    strokeMiterlimit: 10,
    d: "M363.225,179.675c0,2.75-2.25,5-5,5h-59.052c-2.75,0-5-2.25-5-5 v-2.121c0-2.75,2.25-5,5-5h59.052c2.75,0,5,2.25,5,5V179.675z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3A3768",
    strokeMiterlimit: 10,
    d: "M363.225,208.981c0,2.75-2.25,5-5,5h-59.052c-2.75,0-5-2.25-5-5 v-2.121c0-2.75,2.25-5,5-5h59.052c2.75,0,5,2.25,5,5V208.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3A3768",
    strokeMiterlimit: 10,
    d: "M363.225,235.847c0,2.75-2.25,5-5,5h-59.052c-2.75,0-5-2.25-5-5 v-2.121c0-2.75,2.25-5,5-5h59.052c2.75,0,5,2.25,5,5V235.847z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M341.775,180.044c0,2.75-2.25,5-5,5h-39.05c-2.75,0-5-2.25-5-5v-2.859c0-2.75,2.25-5,5-5h39.05 c2.75,0,5,2.25,5,5V180.044z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M356.507,209.351c0,2.75-2.25,5-5,5h-53.782c-2.75,0-5-2.25-5-5v-2.859c0-2.75,2.25-5,5-5h53.782 c2.75,0,5,2.25,5,5V209.351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M322.84,236.216c0,2.75-2.25,5-5,5h-20.115c-2.75,0-5-2.25-5-5v-2.859c0-2.75,2.25-5,5-5h20.115 c2.75,0,5,2.25,5,5V236.216z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    display: "inline",
    overflow: "visible",
    opacity: 0.2,
    width: 476,
    height: 442,
    xlinkHref: "5D4B4BF.jpg",
    transform: "matrix(1.6085 0 0 1.626 186.7021 132.834)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLeft);
export default __webpack_public_path__ + "static/media/background_left.6e79311f3ddc07815576e67680e8a046.svg";
export { ForwardRef as ReactComponent };